import React from 'react';
import ReactDOM from 'react-dom/client';
import demo from './demo';
import reportWebVitals from './reportWebVitals';
import TranslationsContext from "./utils/TranslationsContext";
import Filters, {FilterPropsOperators} from "./Filters";
import getTexts from "./resources/texts"
function renderModule({ id = 'airwpsync-filters', i18n, ...props }) {
    const root = ReactDOM.createRoot(document.getElementById(id));

    const texts = getTexts(i18n);

    root.render(
        <React.StrictMode>
			<TranslationsContext.Provider value={ i18n }>
                <Filters texts={texts} { ...props }></Filters>
			</TranslationsContext.Provider>
        </React.StrictMode>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

window.airWPSyncRenderFilters = renderModule;
window.airWPSyncRenderFilters.FilterPropsOperators = FilterPropsOperators;

if (process.env.NODE_ENV === 'development') {
    demo(renderModule);
}
